import VisuraToExcel from "..";
function Init() {
  return <VisuraToExcel />;
}

export default Init;
